// extracted by mini-css-extract-plugin
module.exports = {"Requests":"Requests_Requests__1BHr0","grid":"Requests_grid__3j8rt","w100":"Requests_w100__o0Z0m","result":"Requests_result__1_Pzc"};